import { render, staticRenderFns } from "./BuilderItem.vue?vue&type=template&id=eba493f6"
import script from "./BuilderItem.vue?vue&type=script&lang=js"
export * from "./BuilderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports